import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDiagramTree16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconDiagramTree16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 1a1.5 1.5 0 1 0-1.415-2H10a2 2 0 0 0-2 2v2.5H6v-2A1.5 1.5 0 0 0 4.5 4h-1A1.5 1.5 0 0 0 2 5.5v5A1.5 1.5 0 0 0 3.5 12h1A1.5 1.5 0 0 0 6 10.5v-2h2V11a2 2 0 0 0 2 2h1.085a1.5 1.5 0 1 0 0-1H10a1 1 0 0 1-1-1V8.5h2.085a1.5 1.5 0 1 0 0-1H9V5a1 1 0 0 1 1-1h1.085A1.5 1.5 0 0 0 12.5 5m-9 0h1a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5M13 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDiagramTree16);
